import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, input, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ClipboardService } from 'ngx-clipboard';
import { RouterSegments } from 'src/app/models/router-segments';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-environment-overview',
  templateUrl: './environment-overview.component.html',
  styleUrl: './environment-overview.component.scss',
  standalone: false,
  animations: [
    trigger('rotate', [
        transition('void=>*', [style({ transform: 'rotate(0)' })]),
        transition('* => *', [
            style({ transform: 'rotate(0)' }),
            animate('650ms ease-in-out', style({ transform: 'rotate(360deg)' })),
        ])
      ])
    ]
})
export class EnvironmentOverviewComponent {

  @Output() refreshInstance = new EventEmitter<void>();
  @Input() data: any;
  @Input() solution: any;
  @Input() solutionVersion: any;
  @Input() getBlueprints: any;
  @Input() hasSecondaryRegion: boolean;
  @Input() isLoading: boolean;
  @Input() count: number;
  currentEnvironment: any;
  copy = false;
  RouterSegments = RouterSegments;

  constructor(private clipboardApi: ClipboardService, private router: Router, private authService: AuthService) {
  }
  
  ngOnInit(): void {
    this.currentEnvironment = (window.location.href.split('.')[0].split('/')[2] === 'dev' ?
    'https://dev.portal.saas.temenos.cloud/' : window.location.href.split('.')[0].split('/')[2] === 'preprod' ?
    'https://preprod.portal.saas.temenos.cloud/' : window.location.href.split('.')[0].split('/')[2] === 'utp' ?
    'https://utp.portal.saas.temenos.cloud/': 'https://portal.bankingcloud.temenos.com/');
  }

  openUrl(): void {
    const url = `${this.currentEnvironment}${this.data?.tenantId}/services/${this.data?.solutionId}/blueprints/${this.data?.blueprintId}`;
    window.open(url, '_blank');
  }

  onCopyId(data): void {
    this.copy = true;
    this.clipboardApi.copyFromContent(data);
    setTimeout(() => {
      this.copy = false;
    }, 500);
  }

  openUrlSolution(id): void {
  this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.data?.tenantId, RouterSegments.SOLUTION,
    this.data?.solutionId, RouterSegments.VERSIONS]);
  }

  openUrlSolutionVersion(id):void{
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.data?.tenantId, RouterSegments.SOLUTION,
      this.data?.solutionId, RouterSegments.VERSIONS, this.data?.solutionVersionId]);

  }

  onRefreshClick() {
    this.refreshInstance.emit();
  }
}
